import { Box } from "@mui/material";
import { Navigation } from "@finpay-development/shared-platform/lib/esm/security/model/navigation";
import  DesktopHeader from "./desktop-header";
import  MobileHeader from "./mobile-header";

interface HeaderProps {
  showLinks?: boolean;
  subNav?: Navigation[];
}

function FppHeader(props: HeaderProps) {

  return (
    <>   
    <Box display={{ xs: 'none', md: 'block' }}>
        <DesktopHeader {...props}/>
    </Box>
    <Box display={{ xs: 'block', md: 'none' }}>
      <MobileHeader {...props}/>
    </Box>
    </>
  );
}

export default FppHeader;
